








































import {
  defineComponent,
  onBeforeMount,
  reactive,
  SetupContext,
  watch,
  computed,
} from '@vue/composition-api';
import EntityDialog from '@/components/common/EntityDialog.vue';
import { ColorGroup } from '@/models/entities/ColorGroup';
import { DropdownFilter } from '@/models/filters/Filters';
import ColorsPaginatedAutocomplete from '@/components/entities/colors/ColorsPaginatedAutocomplete.vue';
import { Color } from '@/models/entities/Color';

interface Props {
  id: string;
}

interface State {
  entity: ColorGroup;
  loading: boolean;
}

const Component = defineComponent({
  name: 'ColorGroupDetail',

  components: {
    EntityDialog,
    ColorsPaginatedAutocomplete,
  },

  props: {
    id: String,
  },

  setup(props: Props, { root: { $store, $router } }: SetupContext) {
    let colorGroup = new ColorGroup({});

    let isNew = () => !props.id;

    onBeforeMount(async () => {
      if (!isNew()) {
        const res = await $store.dispatch(`colorGroupsModule/fetchItem`, props.id);
        if (!res) $router.back();
      }
    });

    const state = reactive({
      entity: colorGroup,
      loading: computed(() => $store.getters['colorGroupsModule/loading']),
    }) as State;

    watch(
      () => $store.getters['colorGroupsModule/selectedItem'],
      (newValue: ColorGroup) => Object.assign(colorGroup, newValue),
      { immediate: false, deep: true },
    );

    const title = computed(() => {
      if (state.loading) return '';
      if (isNew()) return 'New Color Group';
      return `Edit Color Group`;
    });

    const rules = {
      name: [(v: string) => !!v || 'Name is required'],
    };

    function editColors(values: (Color | number)[]) {
      const newColors: Color[] = [];
      values.forEach(value => {
        if (typeof value === 'number') {
          const newColor = state.entity.colors.find(color => color.id === value);
          if (newColor) newColors.push(newColor);
        } else newColors.push(value);
      });
      state.entity.colors = newColors;
      state.entity.totalColors = newColors.length;
    }

    return {
      state,
      title,
      rules,
      isNew,
      DropdownFilter,
      editColors,
    };
  },
});
export default Component;
